var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,attrs:{"id":"qrCode"}},[_c('div',{attrs:{"id":"code"}}),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.text),expression:"text"}],attrs:{"id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }